//@ts-check
import React from 'react';
import Typography from '@material-ui/core/Typography';
import useFormDataLayer from '../logic/useFormDataLayer';
import useFormLayout from '../layout/useFormLayout';
import FormFields from './FormFields';

var ConnectedFormFields = function ConnectedFormFields() {
  var _useFormDataLayer = useFormDataLayer('FORM_PAGES_FIELD'),
      pageId = _useFormDataLayer.value;

  var layout = useFormLayout();
  if (!layout.pages || !layout.pages.length) return React.createElement(Typography, null, "Your form has no visible pages.");
  var pageLayout = layout.containers[pageId];
  if (!pageLayout || !pageLayout.rows) return React.createElement(Typography, null, "This page is empty.");
  return React.createElement(FormFields, {
    pageLayout: pageLayout
  });
};

export default ConnectedFormFields;